const baseAppUrl = typeof window.location !== 'undefined' ? new URL('/', window.location.href).toString() : ''

export const BUILTIN_MARKERS_BASE_PATH = `${baseAppUrl}markers`
export const MAKI_ICONS_BASE_PATH = `${BUILTIN_MARKERS_BASE_PATH}/maki`

export const makiIcons = [
  'aerialway.svg',
  'airfield.svg',
  'airport.svg',
  'alcohol-shop.svg',
  'american-football.svg',
  'amusement-park.svg',
  'animal-shelter.svg',
  'aquarium.svg',
  'arrow.svg',
  'art-gallery.svg',
  'attraction.svg',
  'bakery.svg',
  'bank-JP.svg',
  'bank.svg',
  'bar.svg',
  'barrier.svg',
  'baseball.svg',
  'basketball.svg',
  'bbq.svg',
  'beach.svg',
  'beer.svg',
  'bicycle-share.svg',
  'bicycle.svg',
  'blood-bank.svg',
  'bowling-alley.svg',
  'bridge.svg',
  'building-alt1.svg',
  'building.svg',
  'bus.svg',
  'cafe.svg',
  'campsite.svg',
  'car-rental.svg',
  'car-repair.svg',
  'car.svg',
  'casino.svg',
  'castle-JP.svg',
  'castle.svg',
  'caution.svg',
  'cemetery-JP.svg',
  'cemetery.svg',
  'charging-station.svg',
  'cinema.svg',
  'circle-stroked.svg',
  'circle.svg',
  'city.svg',
  'clothing-store.svg',
  'college-JP.svg',
  'college.svg',
  'commercial.svg',
  'communications-tower.svg',
  'confectionery.svg',
  'construction.svg',
  'convenience.svg',
  'cricket.svg',
  'cross.svg',
  'dam.svg',
  'danger.svg',
  'defibrillator.svg',
  'dentist.svg',
  'diamond.svg',
  'doctor.svg',
  'dog-park.svg',
  'drinking-water.svg',
  'elevator.svg',
  'embassy.svg',
  'emergency-phone.svg',
  'entrance-alt1.svg',
  'entrance.svg',
  'farm.svg',
  'fast-food.svg',
  'fence.svg',
  'ferry-JP.svg',
  'ferry.svg',
  'fire-station-JP.svg',
  'fire-station.svg',
  'fitness-centre.svg',
  'florist.svg',
  'fuel.svg',
  'furniture.svg',
  'gaming.svg',
  'garden-centre.svg',
  'garden.svg',
  'gate.svg',
  'gift.svg',
  'globe.svg',
  'golf.svg',
  'grocery.svg',
  'hairdresser.svg',
  'harbor.svg',
  'hardware.svg',
  'heart.svg',
  'heliport.svg',
  'highway-rest-area.svg',
  'historic.svg',
  'home.svg',
  'horse-riding.svg',
  'hospital-JP.svg',
  'hospital.svg',
  'hot-spring.svg',
  'ice-cream.svg',
  'industry.svg',
  'information.svg',
  'jewelry-store.svg',
  'karaoke.svg',
  'landmark-JP.svg',
  'landmark.svg',
  'landuse.svg',
  'laundry.svg',
  'library.svg',
  'lift-gate.svg',
  'lighthouse-JP.svg',
  'lighthouse.svg',
  'lodging.svg',
  'logging.svg',
  'marker-stroked.svg',
  'marker.svg',
  'mobile-phone.svg',
  'monument-JP.svg',
  'monument.svg',
  'mountain.svg',
  'museum.svg',
  'music.svg',
  'natural.svg',
  'observation-tower.svg',
  'optician.svg',
  'paint.svg',
  'park-alt1.svg',
  'park.svg',
  'parking-garage.svg',
  'parking-paid.svg',
  'parking.svg',
  'pharmacy.svg',
  'picnic-site.svg',
  'pitch.svg',
  'place-of-worship.svg',
  'playground.svg',
  'police-JP.svg',
  'police.svg',
  'post-JP.svg',
  'post.svg',
  'prison.svg',
  'racetrack-boat.svg',
  'racetrack-cycling.svg',
  'racetrack-horse.svg',
  'racetrack.svg',
  'rail-light.svg',
  'rail-metro.svg',
  'rail.svg',
  'ranger-station.svg',
  'recycling.svg',
  'religious-buddhist.svg',
  'religious-christian.svg',
  'religious-jewish.svg',
  'religious-muslim.svg',
  'religious-shinto.svg',
  'residential-community.svg',
  'restaurant-bbq.svg',
  'restaurant-noodle.svg',
  'restaurant-pizza.svg',
  'restaurant-seafood.svg',
  'restaurant-sushi.svg',
  'restaurant.svg',
  'road-accident.svg',
  'roadblock.svg',
  'rocket.svg',
  'school-JP.svg',
  'school.svg',
  'scooter.svg',
  'shelter.svg',
  'shoe.svg',
  'shop.svg',
  'skateboard.svg',
  'skiing.svg',
  'slaughterhouse.svg',
  'slipway.svg',
  'snowmobile.svg',
  'soccer.svg',
  'square-stroked.svg',
  'square.svg',
  'stadium.svg',
  'star-stroked.svg',
  'star.svg',
  'suitcase.svg',
  'swimming.svg',
  'table-tennis.svg',
  'teahouse.svg',
  'telephone.svg',
  'tennis.svg',
  'theatre.svg',
  'toilet.svg',
  'toll.svg',
  'town-hall.svg',
  'town.svg',
  'triangle-stroked.svg',
  'triangle.svg',
  'tunnel.svg',
  'veterinary.svg',
  'viewpoint.svg',
  'village.svg',
  'volcano.svg',
  'volleyball.svg',
  'warehouse.svg',
  'waste-basket.svg',
  'watch.svg',
  'water.svg',
  'waterfall.svg',
  'watermill.svg',
  'wetland.svg',
  'wheelchair.svg',
  'windmill.svg',
  'zoo.svg',
  //
  'ooh-billboard.svg',
  'ooh-marker.svg',
  'tel-add-site.svg',
  'tel-add-site-stroked.svg',
  'tel-communications-tower.svg',
  'tel-in-building.svg',
  'tel-upgrade-site.svg',
  'tel-upgrade-site-stroked.svg'
]
